export const extractLinkFromMessage = (message?: string) => {
	if (!message) return null;
	const regex = /https?:\/\/[^\s]+/;
	const match = message.match(regex);
	return match ? match[0] : null;
};
